export default __webpack_public_path__ + "static/media/decidr.5fcf9849.svg";